import { render } from "./Burgerform.vue?vue&type=template&id=6d889f2b&scoped=true"
import script from "./Burgerform.vue?vue&type=script&lang=js"
export * from "./Burgerform.vue?vue&type=script&lang=js"

import "./Burgerform.vue?vue&type=style&index=0&id=6d889f2b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d889f2b"]])

export default __exports__